module.exports = __webpack_public_path__ + "img/chuang-min.f96fec65.jpg";